import {createApp} from 'vue'
import ElementPlus from 'element-plus'
import App from './App.vue'
import {createPinia} from 'pinia'
import {registerStore} from './store'
import {directive} from './utils/directive'
import {router} from './router'
import {i18n} from './i18n'
import 'virtual:svg-icons-register'

import '@/icons/iconfont/iconfont'
import 'element-plus/dist/index.css'
import '@/styles/index.scss'
import piniaPersist from 'pinia-plugin-persist'
import FastTableColumn from '@/components/fast-table-column'
import FastRadioGroup from '@/components/fast-radio-group'
import FastSelect from '@/components/fast-select'
import FastUser from '@/components/fast-user'
import SvgIcon from '@/components/svg-icon'
import NumberRange from '@/components/number-range'
import FastUpload from "@/components/fast-upload/index";

const app = createApp(App)

// 注册 自定义指令
directive(app)

const pinia = createPinia();
// pinia持久化
pinia.use(piniaPersist)
app.use(pinia)
// 注册 Pinia
registerStore()
app.use(router)
app.use(i18n)
app.use(FastTableColumn)
app.use(FastRadioGroup)
app.use(FastSelect)
app.use(FastUser)
app.use(FastUpload)
app.use(SvgIcon)
app.use(NumberRange)
app.use(ElementPlus)
app.mount('#app')
